import { ProductAvailableFieldModel, ProductModel } from 'Pages/orders'
import { axiosDS } from '@pp/axios'
import { ResponseCatalog, RequestParams, ShortDataModel } from 'Models'
import { urls } from 'Constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'

export const productsApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ProductModel>>(`${urls.orders.products}`, {
			params,
		})
		return res.data
	},
	getOne: async (id: number) => {
		const res = await axiosDS().get<ProductModel>(`${urls.orders.products}/${id}`)
		return res.data
	},
	createOne: async (data: FormData) => {
		const res = await axiosDS().post<ProductModel>(`${urls.orders.products}`, data)
		return res.data
	},
	updateOne: async (id: number, data: FormData) => {
		const res = await axiosDS().patch<ProductModel>(`${urls.orders.products}/${id}`, data)
		return res.data
	},
	restoreOne: async (id: number) => {
		const res = await axiosDS().patch<SimpleResponse>(`${urls.orders.products}/${id}/restore`)
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(`${urls.orders.products}/${id}`)
		return res.data
	},
	productFields: async () => {
		const res = await axiosDS().get<ProductAvailableFieldModel[]>(
			`${urls.orders.products}/available_fields`
		)
		return res.data
	},
	productGroups: async () => {
		const res = await axiosDS().get<ResponseCatalog<ShortDataModel>>(`${urls.orders.product_group}`)
		return res.data
	},
	getAllIntegrationCodes: async () => {
		const res = await axiosDS().get<string[]>(urls.orders.integrationCodes)
		return res.data
	},
}
